import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../auth/authConfig'

const msalInstance = new PublicClientApplication(msalConfig)

export const msalPlugin = {
  install (app) {
    app.config.globalProperties.$msal = msalInstance
  }
}

export default msalInstance
